// Workout Progress Tracking Model
export class WorkoutProgress {
  constructor(data = {}) {
    this.id = data.id || generateId();
    this.exerciseName = data.exerciseName || '';
    this.date = data.date || new Date().toISOString();
    this.sets = data.sets || 3;
    this.reps = data.reps || 10;
    this.weight = data.weight || 0; // in lbs or kg
    this.duration = data.duration || 0; // in seconds
    this.notes = data.notes || '';
    this.completed = data.completed || false;
  }
}

export class WorkoutWeek {
  constructor(weekNumber = 1) {
    this.weekNumber = weekNumber;
    this.startDate = new Date().toISOString();
    this.sessions = [];
  }

  addSession(session) {
    this.sessions.push(session);
  }

  getProgress() {
    const completed = this.sessions.filter(s => s.completed).length;
    const total = this.sessions.length;
    return { completed, total, percentage: total > 0 ? (completed / total) * 100 : 0 };
  }
}

function generateId() {
  return `progress_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
